<template>
    <div
        class="dropdown-menu absolute z-dropdown select-none"
        :class="menuClasses"
    >
        <div class="z-dropdown overflow-hidden bg-white border border-50 shadow rounded-lg">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            direction: {
                type: String,
                default: 'ltr',
                validator: (value) => ['ltr', 'rtl'].indexOf(value) != -1,
            },
        },
        computed: {
            menuClasses() {
                return [this.direction == 'ltr' ? 'dropdown-menu-left' : 'dropdown-menu-right'];
            },
        },
    };
</script>
